import type { Control, FieldErrors } from "react-hook-form";
import type {
  FormFieldData,
  FormInputData
} from "../../../../../../BuildingBlocks/Forms/Controllers/FormFieldController";
import { FormFieldController } from "../../../../../../BuildingBlocks/Forms/Controllers/FormFieldController";
import { isFieldError } from "../../../../../../BuildingBlocks/Forms/MantineFormFields/HelperText/utils/isFieldError";
import type { ChangeableFieldErrors } from "../../../../../../ChangeableFieldWidget/ChangeableFieldTable/ChangeableFieldTable";
import { ChangeablePricesField } from "../../../../SharedFields/ChangeablePricesField";
import { DELIVERY_FORM_HELP_TEXTS } from "../../DeliveryForm.constants";
import type { DeliveryFormFields } from "../../DeliveryForm.types";
import { ChangeableSpotMarketField } from "../ChangeableSpotMarketField/ChangeableSpotMarketField";

interface ForwardPassingOnFieldsProps {
  control: Control<DeliveryFormFields>;
  errors: FieldErrors<DeliveryFormFields>;
  formFieldData: FormFieldData<DeliveryFormFields>;
  useSpotMarketPrices?: boolean;
  areSpotMarketPricesAvailable?: boolean;
  spotMarketPricesError?: ChangeableFieldErrors;
}

function ForwardPassingOnFields({
  control,
  errors,
  formFieldData,
  useSpotMarketPrices,
  areSpotMarketPricesAvailable,
  spotMarketPricesError
}: ForwardPassingOnFieldsProps) {
  return (
    <>
      {areSpotMarketPricesAvailable && (
        <FormFieldController
          control={control}
          data={
            formFieldData.useSpotMarketPrices as FormInputData<
              DeliveryFormFields,
              "useSpotMarketPrices"
            >
          }
          error={errors.useSpotMarketPrices}
        />
      )}
      {areSpotMarketPricesAvailable && useSpotMarketPrices ? (
        <ChangeableSpotMarketField
          className="SpotMarketPrices"
          control={control}
          errors={spotMarketPricesError}
          label={"Börsenpreis Formel (netto)*"}
          name="spotMarketPrices"
          unit="ct/kWh"
        />
      ) : (
        <ChangeablePricesField
          className="WorkingPrices"
          control={control}
          error={
            isFieldError(errors.workingPrices)
              ? errors.workingPrices
              : undefined
          }
          helpText={DELIVERY_FORM_HELP_TEXTS.workingPrices}
          label={"Arbeitspreis exkl. Abgaben/Umlagen, exkl. MWSt.*"}
          name="workingPrices"
          unit="ct/kWh"
        />
      )}
      <ChangeablePricesField
        className="ConcessionFees"
        control={control}
        error={
          isFieldError(errors.concessionFees)
            ? errors.concessionFees
            : undefined
        }
        helpText={DELIVERY_FORM_HELP_TEXTS.concessionFees}
        label={"Konzessionsabgabe"}
        name="concessionFees"
        unit="ct/kWh"
      />
    </>
  );
}

export { ForwardPassingOnFields };
